import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { initMetaPixel } from "@/lib/metaPixel";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SubscriptionGate from "@/components/SubscriptionGate";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Subscribe from "@/pages/Subscribe";
import Dashboard from "@/pages/Dashboard";
import Agenda from "@/pages/Agenda";
import Clients from "@/pages/Clients";
import Facturation from "@/pages/Facturation";
import Finances from "@/pages/Finances";
import Depenses from "@/pages/Depenses";
import Prospects from "@/pages/Prospects";
import Install from "@/pages/Install";
import Protection from "@/pages/Protection";
import Settings from "@/pages/Settings";
import Onboarding from "@/pages/Onboarding";
import RefundPolicy from "@/pages/RefundPolicy";
import Privacy from "@/pages/Privacy";
import PublicBooking from "@/pages/PublicBooking";

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Landing />;
  return <Navigate to={user.subscription_status === "active" ? "/dashboard" : "/subscribe"} replace />;
}

const gatedPage = (Component) => (
  <SubscriptionGate>
    <Layout>
      <Component />
    </Layout>
  </SubscriptionGate>
);

function App() {
  useEffect(() => { initMetaPixel(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/install" element={<Install />} />
            <Route path="/politique-remboursement" element={<RefundPolicy />} />
            <Route path="/politique-confidentialite" element={<Privacy />} />
            <Route path="/r/:slug" element={<PublicBooking />} />
            <Route path="/subscribe" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
            <Route path="/onboarding" element={
              <SubscriptionGate>
                <Onboarding />
              </SubscriptionGate>
            } />

            <Route path="/dashboard" element={gatedPage(Dashboard)} />
            <Route path="/agenda" element={gatedPage(Agenda)} />
            <Route path="/clients" element={gatedPage(Clients)} />
            <Route path="/facturation" element={gatedPage(Facturation)} />
            <Route path="/finances" element={gatedPage(Finances)} />
            <Route path="/depenses" element={gatedPage(Depenses)} />
            <Route path="/prospects" element={gatedPage(Prospects)} />
            <Route path="/protection" element={gatedPage(Protection)} />
            <Route path="/settings" element={gatedPage(Settings)} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
